export enum AutoBookmarkTypeFilter {
    All = 'all',
    Editor = 'editor',
    Creator = 'creator',
}
